import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Carte produit : ajout rapide et changement de coloris.
 *
 * L'ajout au panier passe par l'évènement standard d'Horizon, pas par une
 * mécanique parallèle : le tiroir, la pastille de panier et le récapitulatif
 * se mettent à jour d'eux-mêmes et ne peuvent pas diverger de la vérité.
 */

const DONE_MS = 1500;

function card(el) {
  return el.closest('[data-lrs-card]');
}

/**
 * N'expose que les tailles du coloris affiché. Sans ce filtre, la rangée
 * listerait toutes les combinaisons et répéterait chaque taille autant de fois
 * qu'il y a de coloris.
 */
function filterSizes(root) {
  const active = root.dataset.activeColor || '';
  root.querySelectorAll('[data-lrs-variant]').forEach((button) => {
    const color = button.dataset.color || '';
    button.hidden = color !== '' && color !== active;
  });
}

/** Bascule la rangée de tailles en boutons cliquables. */
function openPicker(root) {
  const list = root.querySelector('[data-lrs-size-list]');
  const pick = root.querySelector('[data-lrs-size-pick]');
  const button = root.querySelector('[data-lrs-quickadd]');
  if (!pick) return;

  filterSizes(root);
  pick.hidden = false;
  if (list) list.hidden = true;
  if (button) button.hidden = true;

  const first = pick.querySelector('button:not([disabled]):not([hidden])');
  first?.focus();
}

function flash(root, message) {
  const button = root.querySelector('[data-lrs-quickadd]');
  const list = root.querySelector('[data-lrs-size-list]');
  const pick = root.querySelector('[data-lrs-size-pick]');
  if (!button) return;

  const previous = button.textContent;
  button.hidden = false;
  button.textContent = message;
  button.classList.add('is-done');
  if (pick) pick.hidden = true;
  if (list) list.hidden = false;

  window.setTimeout(() => {
    button.textContent = previous;
    button.classList.remove('is-done');
  }, DONE_MS);
}

async function addToCart(root, variantId) {
  const deferred = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });

    if (!response.ok) throw new Error(`Réponse ${response.status}`);

    deferred.resolve({ detail: { didError: false } });
    flash(root, 'Ajouté ✓');
  } catch (error) {
    deferred.resolve({ detail: { didError: true } });
    flash(root, 'Indisponible');
  }
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  // --- bouton principal
  const trigger = target.closest('[data-lrs-quickadd]');
  if (trigger) {
    const root = card(trigger);
    if (!root) return;
    event.preventDefault();

    if (root.dataset.single === 'true') {
      const only = root.querySelector('[data-lrs-variant]:not([disabled])');
      if (only) addToCart(root, only.dataset.lrsVariant);
      return;
    }
    openPicker(root);
    return;
  }

  // --- choix d'une taille
  const size = target.closest('[data-lrs-variant]');
  if (size && !size.disabled) {
    const root = card(size);
    if (!root) return;
    event.preventDefault();
    addToCart(root, size.dataset.lrsVariant);
    return;
  }

  // --- pastille de couleur : change l'image sans quitter la page
  const swatch = target.closest('[data-lrs-color]');
  if (swatch) {
    const root = card(swatch);
    if (!root) return;
    event.preventDefault();

    const image = root.querySelector('[data-lrs-main]');
    const src = swatch.dataset.image;
    if (image && src) {
      image.removeAttribute('srcset');
      image.src = src;
    }

    root.querySelectorAll('[data-lrs-color]').forEach((s) => s.classList.remove('is-on'));
    swatch.classList.add('is-on');

    // La rangée d'ajout rapide suit le coloris : sinon elle proposerait des
    // tailles d'un autre coloris que celui affiché.
    root.dataset.activeColor = swatch.dataset.color || '';
    filterSizes(root);
  }
});

// Échap referme la rangée de tailles.
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-lrs-size-pick]:not([hidden])').forEach((pick) => {
    const root = card(pick);
    pick.hidden = true;
    root?.querySelector('[data-lrs-size-list]')?.removeAttribute('hidden');
    const button = root?.querySelector('[data-lrs-quickadd]');
    if (button) {
      button.hidden = false;
      button.focus();
    }
  });
});
